import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ProfileSideCompanies = () => (
  <Box sx={{ backgroundColor: 'secondary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">itau - /app/profile/empresas</Typography>
  </Box>
);

export default ProfileSideCompanies;
